import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService, AuthConfig } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root',
})
export class AuthGoogleService {
  constructor(private oAuthService: OAuthService, private router: Router,) {
    this.tokenLogin();
    this.initLogin();
  }

  initLogin() {
    console.log('first');
    const config: AuthConfig = {
      issuer: 'https://accounts.google.com',
      strictDiscoveryDocumentValidation: false,
      clientId:
        '650083898690-417ssmohqmr9djtt6h254j2g7405gosu.apps.googleusercontent.com',
      redirectUri: window.location.origin + '/authentication/procces-data',
      scope: 'openid profile email',
    };

    this.oAuthService.configure(config);
    this.oAuthService.setupAutomaticSilentRefresh();
    this.oAuthService.loadDiscoveryDocumentAndTryLogin();
  }

  tokenLogin() {
    const token = localStorage.getItem('token');
    const tokenGoogle = this.oAuthService.getAccessToken();
    if (token) {
      this.router.navigateByUrl('/dashboards');
    }
    else if (tokenGoogle) {
      this.router.navigateByUrl('/dashboards');
    }
    else if (this.oAuthService.hasValidAccessToken()!) {
      this.oAuthService.revokeTokenAndLogout();
    }

  }

  loginGoogle() {
    this.oAuthService.initLoginFlow();
  }

  legoutGoogle() {
    this.oAuthService.logOut();
  }

  getGoogleAccessToken() {
    return this.oAuthService.getAccessToken();
  }

  getGoogleEmail() {
    return this.oAuthService.getIdentityClaims();
  }

  getProfile() {
    return this.oAuthService.getIdentityClaims();
  }

  getToken() {
    return this.oAuthService.getAccessToken();
  }
}
